import { provide, ref } from 'vue'

export const useSortingProvider = ({ initialState, sortingOptions }) => {
  const sortingState = ref({ ...initialState })

  const updateSortingState = (field, order) => {
    sortingState.value.field = field
    sortingState.value.order = order
  }

  const loadPreselectedSorting = (params) => {
    Object.keys(params).forEach((key) => {
      const iSortingOption = Object.keys(sortingState.value).includes(key)
      if (!iSortingOption) return
      sortingState.value[key] = params[key]
    })
  }

  provide('sortingState', sortingState)
  provide('updateSortingState', updateSortingState)
  provide('sortingOptions', sortingOptions)

  return {
    sortingState,
    updateSortingState,
    loadPreselectedSorting,
  }
}
